import { useEmployeeGoalsPrivileges } from './useEmployeeGoalsPrivileges';

const useOKRBulkUploadPermissionsBasedOnEmployeeGoalsPrivileges = () => {
  const { hasBulkUploadObjectivesPrivilege, hasBulkUploadKeyResultsPrivilege, hasBulkUploadInitiativesPrivilege } =
    useEmployeeGoalsPrivileges();

  const canBulkUploadObjectives = hasBulkUploadObjectivesPrivilege;
  const canBulkUploadKeyResults = hasBulkUploadKeyResultsPrivilege;
  const canBulkUploadInitiatives = hasBulkUploadInitiativesPrivilege;

  return {
    canBulkUploadObjectives,
    canBulkUploadKeyResults,
    canBulkUploadInitiatives,
  };
};

export default useOKRBulkUploadPermissionsBasedOnEmployeeGoalsPrivileges;
